import Vue from "vue"
import { MutationTree } from "vuex/types"

import { NavigationColumn, EnvironmentState } from "./environment.types"
import { transformRoutes } from "./transformations"

const mutations: MutationTree<EnvironmentState> = {
  SET_WEBVIEW (state, isWebview) {
    state.webview = isWebview
  },

  SET_THEME_COLOR (state, color) {
    Vue.set(state.theme, 'color', color)
  },

  SET_LANGUAGES (state, languages) {
    state.languages = languages
  },

  SET_HEADER (state, header) {
    state.header = {
      ...header,
      items: transformRoutes(header.items)
    }
  },

  SET_FOOTER (state, footer) {
    state.footer = {
      ...footer,
      columns: footer.columns.map((column: NavigationColumn) => ({ ...column, items: transformRoutes(column.items) }))
    }
  }
}

export default mutations
